import { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { push } from 'connected-react-router'
import { moviesUpdateItem, movieExtensionsUpdateItem, movieExtensionsAddItemToReset } from '../../../actions/index'
import toJS from '../../../hoc/toJS'
import getData from '../../../functions/getData'
import {
    PROGRAM_CLI_MOVIES_ITEMS,
    PROGRAM_PERFORMANCES,
    PROGRAM_ATTRIBUTES,
    PROGRAM_MOVIEEXTENSIONS_ITEMS,
    PROGRAM_MOVIEMAPPING_ITEMS,
    PROGRAM_PY_MOVIES_ITEMS,
    PROGRAM_KH_MOVIES_ITEMS,
    PROGRAM_COMP_MOVIES_ITEMS,
    PROGRAM_META_MOVIES_ITEMS,
    PROGRAM_MOVIEEXTENSIONS_ITEMS_TO_RESET,
    PROGRAM_DIESEL_MOVIES_ITEMS,
    PROGRAM_CORTEC_MOVIES_ITEMS,
    PROGRAM_VISTA_MOVIES_ITEMS,
    PROGRAM_MARSX_MOVIES_ITEMS,
    PROGRAM_PM_MOVIES_ITEMS,
    PROGRAM_TMDB_MOVIES_ITEMS,
} from '../../../constants/state'
import EditMovie from '../present/EditMovie'
import { ORIGIN_DATA_PROVIDER, ORIGIN_PM } from '../../../constants/metaMovieOrigins'
import getSourceMovies from '../../../functions/getSourceMovies'
import { toStartingDateString } from '../../../functions/pmStartingDate'

const mapStateToProps = (state, ownProps) => ({
    movies: getData(state, PROGRAM_CLI_MOVIES_ITEMS),
    performances: getData(state, PROGRAM_PERFORMANCES),
    attributes: getData(state, PROGRAM_ATTRIBUTES),
    movieExtensionsItems: getData(state, PROGRAM_MOVIEEXTENSIONS_ITEMS),
    movieExtensionsToReset: getData(state, PROGRAM_MOVIEEXTENSIONS_ITEMS_TO_RESET),
    movieMappings: getData(state, PROGRAM_MOVIEMAPPING_ITEMS),
    metaMovie: getData(state, [PROGRAM_META_MOVIES_ITEMS, ownProps.itemId]),
    pmMovies: getData(state, PROGRAM_PM_MOVIES_ITEMS),
    tmdbMovies: getData(state, PROGRAM_TMDB_MOVIES_ITEMS),
    pyMovies: getData(state, PROGRAM_PY_MOVIES_ITEMS),
    dieselMovies: getData(state, PROGRAM_DIESEL_MOVIES_ITEMS),
    khMovies: getData(state, PROGRAM_KH_MOVIES_ITEMS),
    compMovies: getData(state, PROGRAM_COMP_MOVIES_ITEMS),
    cortecMovies: getData(state, PROGRAM_CORTEC_MOVIES_ITEMS),
    vistaMovies: getData(state, PROGRAM_VISTA_MOVIES_ITEMS),
    marsxMovies: getData(state, PROGRAM_MARSX_MOVIES_ITEMS),
    previewMoviePk: getData(state, [PROGRAM_MOVIEMAPPING_ITEMS, ownProps.itemId, 'preview']) || null,
    timezone: state.getIn(['translation', 'timezone']),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    onUpdateItem: (itemData, metaData, previewMoviePk = null, expectedStartDate = null, startDateDescription = null, timezone = null) => {
        const updateLocal = !ownProps.updateRemote
        dispatch(moviesUpdateItem(ownProps.itemId, itemData.movie, itemData.attributes, metaData, updateLocal, previewMoviePk, expectedStartDate, startDateDescription, timezone))
    },
    onUpdateExtension: (pk, extension, data) => {
        dispatch(movieExtensionsUpdateItem(pk, extension, data))
    },
    onResetExtension: (pk, extension) => {
        dispatch(movieExtensionsUpdateItem(pk, extension, null))
        dispatch(movieExtensionsAddItemToReset(pk))
    },
    onNavigate: (path) => dispatch(push(path)),
})

class EditMovieContainer extends Component {
    constructor(props) {
        super(props)

        const { metaMovie } = this.props

        this.state = {
            metaData: metaMovie ? metaMovie : false,
            movieExtensionsToReset: []
        }

        this.setMeta = this.setMeta.bind(this)
        this.onChangeField = this.onChangeField.bind(this)
        this.onResetField = this.onResetField.bind(this)
        this.onSetOrigin = this.onSetOrigin.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        const {  metaData } = this.state
        const { metaMovie } = nextProps
        
        this.initMeta( metaData, metaMovie)
    }

    initMeta(metaData, metaMovie) {
        if(!metaData) {
            this.setState({
                metaData: metaMovie
            })
        }
    }

    setMeta(key, origin) {
        const { metaData } = this.state

        if(origin !== metaData[key]) {
            this.setState({
                metaData: {
                    ... metaData,
                    [key]: origin
                }
            })
        }
    }

    onChangeField(key) {
        this.setMeta(key, ORIGIN_PM)
    }

    onResetField(key) {
        this.setMeta(key, ORIGIN_DATA_PROVIDER)
    }

    onSetOrigin(key, origin) {
        this.setMeta(key, origin)
    }

    render() {
        const { itemId, movies, movieMappings, metaMovie, performances, attributes, closePagePath, onUpdateItem, previewMoviePk, movieExtensionsItems, movieExtensionsToReset, onUpdateExtension, onResetExtension, khMovies, compMovies, pyMovies, dieselMovies, cortecMovies, vistaMovies, marsxMovies, onNavigate, pmMovies, tmdbMovies, timezone } = this.props
        const { metaData } = this.state
        const movieExist = movies && movies.hasOwnProperty(itemId) && movies[itemId]
        const isTmdbLinked = !!(movieMappings && movieMappings[itemId] && movieMappings[itemId].tmdb)
        const hasPreviewMovie = !!previewMoviePk

        const wrappedOnUpdateItem = (itemData, metaOrigins) => {
            let previewPkForUpdate = null
            let expectedStartDate = null
            let startDateDescription = null
            if (previewMoviePk) {
                expectedStartDate = toStartingDateString(itemData.movie.startingDate, timezone)
                startDateDescription = itemData.movie.startDateDescription || null
                previewPkForUpdate = previewMoviePk
            }
            onUpdateItem(itemData, metaOrigins, previewPkForUpdate, expectedStartDate, startDateDescription, timezone)
        }

        const sourceMoviesByItemId = movieExist && !_.isEmpty(movieMappings) ? movieMappings[itemId].source : null
        const cliMovieRelevantSourceMovies = getSourceMovies(sourceMoviesByItemId, khMovies, compMovies, pyMovies, dieselMovies, cortecMovies, vistaMovies, marsxMovies)
        const sourceData = cliMovieRelevantSourceMovies ? cliMovieRelevantSourceMovies[Object.keys(cliMovieRelevantSourceMovies)[0]] : {}
        let sourceDataProvider = null
        const pmMovie = pmMovies && movieMappings && movieMappings[itemId] && movieMappings[itemId].pm ? pmMovies[String(movieMappings[itemId].pm)] : null
        const tmdbMovie = tmdbMovies && movieMappings && movieMappings[itemId] && movieMappings[itemId].tmdb ? tmdbMovies[movieMappings[itemId].tmdb] : null

        if(movieExist && sourceMoviesByItemId && sourceMoviesByItemId.length > 0 && !sourceData) {
            return ''
        }

        sourceMoviesByItemId && sourceMoviesByItemId.map(movieSource => {
            _.keys(movieSource).map(movieSourceKey => {
                const movieSourceMovieId = movieSource[movieSourceKey]
                if(movieSourceMovieId === sourceData.pk) {
                    sourceDataProvider = movieSourceKey
                }
            })
        })

        return <EditMovie
            itemId={itemId}
            closePagePath={closePagePath}
            movies={movies}
            metaData={metaData}
            sourceData={sourceData}
            movieExtensionsItems={movieExtensionsItems}
            movieExtensionsToReset={movieExtensionsToReset}
            performances={performances}
            attributes={attributes}
            sourceDataProvider={sourceDataProvider}
            movieExist={movieExist}
            sourceMoviesByItemId={sourceMoviesByItemId}
            cliMovieRelevantSourceMovies={cliMovieRelevantSourceMovies}
            onUpdateItem={wrappedOnUpdateItem}
            onUpdateExtension={onUpdateExtension}
            onResetExtension={onResetExtension}
            onChangeField={this.onChangeField}
            onResetField={this.onResetField}
            isTmdbLinked={isTmdbLinked}
            hasPreviewMovie={hasPreviewMovie}
            onSetOrigin={this.onSetOrigin}
            onNavigate={onNavigate}
            pmMovie={pmMovie}
            tmdbMovie={tmdbMovie}
        />
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(EditMovieContainer)